import React from "react";

/**
 * Componente Button con diseño elegante inspirado en bodas de Puebla
 * Variantes: primary, secondary, outline
 * Tamaños: sm, md, lg
 */
const Button = ({
  children,
  onClick,
  variant = "primary",
  size = "md",
  type = "button",
  disabled = false,
  className = "",
  icon = null,
  fullWidth = false,
}) => {
  // Estilos base
  const baseStyles =
    "font-sans font-semibold rounded-elegant transition-all duration-300 flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-primary-light";

  // Variantes de estilo
  const variants = {
    primary:
      "bg-gradient-to-br from-primary to-primary-light text-white shadow-elegant hover:shadow-elegant-hover hover:-translate-y-0.5 active:translate-y-0",
    secondary:
      "bg-gradient-to-br from-secondary to-secondary-light text-white shadow-elegant hover:shadow-elegant-hover hover:-translate-y-0.5 active:translate-y-0",
    outline:
      "border-2 border-primary text-primary bg-transparent hover:bg-primary hover:text-white",
    gold: "bg-gradient-to-br from-accent-gold to-yellow-400 text-primary shadow-elegant hover:shadow-elegant-hover hover:-translate-y-0.5",
    ghost: "text-primary hover:bg-accent-rose",
  };

  // Tamaños
  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg",
  };

  // Estado disabled
  const disabledStyles = disabled
    ? "opacity-50 cursor-not-allowed pointer-events-none"
    : "cursor-pointer";

  // Width completo
  const widthStyles = fullWidth ? "w-full" : "";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${disabledStyles} ${widthStyles} ${className}`}
    >
      {icon && <span className="flex-shrink-0">{icon}</span>}
      <span>{children}</span>
    </button>
  );
};

export default Button;
